import React, { useState } from 'react';
import { toast } from 'sonner';
import { Scale, Undo2, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Doctrina en Escritos: rulings auto-inserted to back the cited doctrine; the lawyer can remove or restore each one
export const BriefRulings = ({ matter, brief, deadline, onChange }) => {
  const { api } = useAuth();
  const [busy, setBusy] = useState(null);
  const rows = brief.doctrine_rulings || [];
  const contra = brief.contra_rulings || [];
  const sala = (brief.sala_rulings || []).map((r) => ({ ...r, tribunal: `${r.tribunal || ''} · ${r.sala}`, tema: `de la sala: ${r.resultado || 'resultado no informado'}`, deSala: true }));
  if (!brief.doctrine_used?.length && !contra.length && !sala.length) return null;
  const toggle = async (r) => {
    setBusy(r.id);
    try {
      const res = await api.patch(`/crm/matters/${matter.id}/brief/rulings/${r.id}`, { removed: !r.removed, deadline_id: deadline?.id || null });
      onChange(res.data);
    } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo actualizar'); } finally { setBusy(null); }
  };
  return (
    <div data-testid="brief-doctrine-rulings" className="rounded-xl border border-violet-500/30 bg-violet-500/10 p-4 text-xs">
      <p className="mb-1 flex items-center gap-1.5 font-semibold text-violet-200"><Scale className="h-4 w-4" />{rows.length || contra.length || brief.doctrine_used?.length ? 'Fallos que respaldan la doctrina citada, citas de la sala y contrarios neutralizados' : 'Jurisprudencia de la sala citada en el escrito'}</p>
      {!rows.length && brief.doctrine_used?.length > 0 && <p data-testid="brief-doctrine-rulings-empty" className="text-slate-400">Ningún fallo verificado respalda la doctrina citada: se citó solo al autor.</p>}
      {[...rows, ...sala, ...contra.map((r) => ({ ...r, contra: true }))].map((r) => (
        <div key={r.id} data-testid={`brief-ruling-${r.id}`} className={`mt-2 flex items-start gap-2 ${r.removed ? 'opacity-50' : ''}`}>
          <p className="flex-1 text-slate-200"><b>{r.rol}</b> · {r.tribunal}{r.fecha ? ` · ${r.fecha}` : ''} {r.contra && <span data-testid={`brief-contra-${r.id}`} className="text-rose-300">{r.origen === 'doctrina_causa' ? 'contrario a la doctrina de la causa, neutralizado · ' : 'contrario neutralizado · '}</span>}<span className="text-slate-400">({r.tema}{r.autores?.length ? `: ${r.autores.join(', ')}` : ''})</span></p>
          <button data-testid={`brief-ruling-toggle-${r.id}`} disabled={busy === r.id} onClick={() => toggle(r)} className="flex shrink-0 items-center gap-1 rounded-full border border-slate-600 px-2 py-0.5 text-[11px] text-slate-300 hover:text-white disabled:opacity-50">
            {r.removed ? <><Undo2 className="h-3 w-3" />Restaurar</> : <><X className="h-3 w-3" />Quitar</>}
          </button>
        </div>
      ))}
    </div>
  );
};
